// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#edit-member-form .dropdown-state-picker input,#edit-member-form .dropdown-country-picker input{text-align:center}\n", ""]);
// Exports
module.exports = exports;
